import React, { useState } from "react";
import HeroSection from "../components/HomePage/HeroSection";
import WatchPriceIndexSection from "../components/HomePage/WatchPriceIndexSection";
import BrandSuggestionSection from "../components/HomePage/BrandSuggestionSection";
import PortfolioSection from "../components/HomePage/PortfolioSection";
import BuyerProtectionSection from "../components/HomePage/BuyerProtectionSection";
import MajorCategorySection from "../components/HomePage/MajorCategorySection";
import PopularProductSection from "../components/HomePage/PopularProductSection";
import MagazineSection from "../components/HomePage/MagazineSection";
import TrendSection from "../components/HomePage/TrendSection";
import LatestVideoSection from "../components/HomePage/LatestVideoSection";
import MoreProductLinks from "../components/HomePage/MoreProductLinks";
import ReviewSectionBasic from "../components/Shared/ReviewSectionBasic";
import FaqAndContactSection from "../components/Shared/FaqAndContactSection";
import { PlatformSection } from "../components/HomePage/PlatformSection";
import { HowItWorks } from "../components/HomePage/HowItWorks";
import { GetStarted } from "../components/HomePage/GetStartedButton";
import { CrossFillMini } from "../assets/SvgIcons";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const reviews = [
  {
    href: "https://example.com/reviews/123456",
    rating: 5,
    date: "This week",
    review:
      "WristLink has transformed my business. The commission-free model means more profits, and the network is full of serious, verified dealers.",
    reviewer: {
      name: "Ahmed K., Watch Dealer",
      location: "UAE",
      initial: "A",
      color: "blue",
    },
  },
  {
    href: "https://example.com/reviews/654321",
    rating: 5,
    date: "Last week",
    review:
      "A game-changer! WristLink’s exclusive network of professionals makes trading so much easier and more secure.",
    reviewer: {
      name: "Lily R., Luxury Watch Merchant",
      location: "UAE",
      initial: "L",
      color: "red",
    },
  },
  {
    href: "https://example.com/reviews/789101",
    rating: 5,
    date: "This month",
    review:
      "I love that there are no hidden fees, and I know I’m dealing with other professionals. WristLink is exactly what this industry needed.",
    reviewer: {
      name: "John S., Premium Dealer",
      location: "UAE",
      initial: "J",
      color: "green",
    },
  },
];

const faqs = [
  {
    id: 350,
    question: "How does WristLink verify dealers?",
    answer:
      "We ensure authenticity by verifying each dealer's trade license and ID. This rigorous process guarantees a trusted and professional network for all members.",
  },
  {
    id: 351,
    question: "What makes WristLink different from other platforms?",
    answer:
      "WristLink is exclusively designed for dealers, creating a focused and professional environment tailored to your business needs.",
  },
  {
    id: 352,
    question: "Are there any hidden fees?",
    answer:
      "No, there are no hidden fees. WristLink operates solely on a subscription service, ensuring complete transparency and value for our users.",
  },
  {
    id: 353,
    question: "How do I connect with other dealers?",
    answer:
      "Use our platform’s search and messaging tools to connect directly with verified dealers. Build your network and grow your business seamlessly on WristLink.",
  },
];

const HomePage = () => {
  const isAuthorized = true;

  const isSubscribed = localStorage.getItem("sub");

  const [isModalOpen, setIsModalOpen] = useState(!isSubscribed);
  const [email, setEmail] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleNewsletter = () => {
    if (email !== "") {
      toast.success("Subscribed to WristLink Newsletter!");
      localStorage.setItem("sub", true);
      closeModal();
    } else {
      toast.error("Email is required.");
    }
  };
  return (
    <>
      <HeroSection />
      <PlatformSection />
      <HowItWorks />
      {/* <WatchPriceIndexSection /> */}
      <GetStarted />
      {/* {isAuthorized && (
        <> */}
      {/* <BrandSuggestionSection /> */}
      {/* <PortfolioSection /> */}
      {/* <BuyerProtectionSection /> */}
      {/* <MajorCategorySection /> */}
      {/* <PopularProductSection /> */}

      {/* <ReviewSectionBasic
        reviews={reviews}
        sectionClassName={"bg-secondary text-white"}
        sectionTitle={"What Our Members Say"}
        sectionSubTitle={"Reviews from watch dealers"}
      /> */}
      {/* <MagazineSection /> */}
      {/* <TrendSection /> */}
      {/* <LatestVideoSection /> */}
      {/* <MoreProductLinks /> */}
      <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
        <FaqAndContactSection
          faqs={faqs}
          title={"Frequently Asked Questions"}
          email={""}
          phone={""}
        />
      </section>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-2xl w-full max-w-[720px]">
            <div className="flex justify-between items-start">
              <CardHeader
                icon={"https://cdn-icons-png.flaticon.com/128/3356/3356653.png"}
                title={"WristLink  Newsletter"}
                navLink={""}
              />
              <button className="" onClick={closeModal}>
                {CrossFillMini}
              </button>
            </div>
            <div className="border rounded-lg p-4">
              <p className="lg:text-[20px] md:text-[18px] sm:text-[16px] ">
                Stay in the Know
              </p>
              <p className="text-[14px] my-2">
                Beautiful watches, exciting offers, and helpful information.
                Subscribe now for free.
              </p>

              <div className="form-group mb-4">
                <input
                  type="text"
                  id="email"
                  name="email"
                  required
                  className="mt-1 mb-4 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div className="flex  items-start mb-4">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="userLoginPagePermanently"
                      name="LoginPagePermanently"
                      className="mr-2"
                    />
                  </div>
                  <p className="text-[14px]">
                    I would like to receive newsletters about price changes,
                    financial performance updates, the latest trends, and new
                    listings via email. I am aware that I can unsubscribe from
                    these newsletters at any time.
                  </p>
                </div>
              </div>

              <button
                onClick={() => handleNewsletter()}
                className="bg-black text-white py-2.5 rounded-lg w-full"
              >
                {" "}
                Subscribe now for free
              </button>
            </div>
          </div>
        </div>
      )}
      {/* </>
      )} */}
    </>
  );
};

export default HomePage;

const CardHeader = ({ icon, title, navLink }) => {
  return (
    <div className="flex justify-between items-center gap-4 mb-2.5">
      <div className="flex items-center gap-2">
        <img src={icon} height={22} width={22} alt="" />
        <p className="lg:text-[22px] md:text-[20px] sm:text-[18px] ">{title}</p>
      </div>
    </div>
  );
};
